/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteCreationMethods;

(function (QuoteCreationMethods) {
  QuoteCreationMethods["SYSTEM"] = "system";
  QuoteCreationMethods["MANUAL"] = "manual";
})(QuoteCreationMethods || (QuoteCreationMethods = {}));